import { render, staticRenderFns } from "./UserCoupon.vue?vue&type=template&id=0bd4fc4e"
import script from "./UserCoupon.vue?vue&type=script&lang=js"
export * from "./UserCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports